module.exports = __webpack_public_path__ + "img/delete-all-words.63751ad4.svg";